import script from "./manage-admin.vue?vue&type=script&lang=ts&setup=true"
export * from "./manage-admin.vue?vue&type=script&lang=ts&setup=true"

import "./manage-admin.vue?vue&type=style&index=0&id=a068545c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.31_vue@3.5.31_typescript@5.6.3__webpack@5.105.4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a068545c"]])

export default __exports__